import { avatar, el } from "../atoms/dom";
import { icon } from "../atoms/icons";

const items = [
  ["home", "Genel Bakış", "home"],
  ["calendar", "Takvim", "calendar"],
  ["calls", "Görüşmeler", "calls"],
  ["customers", "Müşteriler", "users"],
  ["manage", "Yönet", "manage"],
] as const;

export function sidebar(
  active: string,
  businessName: string,
  initials: string,
  onNavigate: (route: string) => void,
) {
  const nav = el("nav", { className: "sidebar__nav" });
  for (const [route, label, iconName] of items) {
    nav.append(
      el(
        "button",
        {
          className: `nav-item ${active === route ? "is-active" : ""}`,
          attrs: { type: "button" },
          onClick: () => onNavigate(route),
        },
        icon(iconName),
        el("span", { text: label }),
      ),
    );
  }
  return el(
    "aside",
    { className: "sidebar" },
    el(
      "div",
      { className: "brand" },
      el("div", { className: "brand__mark", text: "C2" }),
      el(
        "div",
        {},
        el("strong", { text: "Call2app" }),
        el("span", { text: "Business Web" }),
      ),
    ),
    nav,
    el(
      "div",
      { className: "sidebar__profile" },
      avatar(initials),
      el(
        "div",
        {},
        el("strong", { text: businessName }),
        el("span", { text: "Bağlı işletme" }),
      ),
    ),
  );
}
